import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import type { NetworkPlacement } from "./types";

export const localStateSelector = makeModuleStateSelector<NetworkPlacement.State>(defaultState, previewState);
